export default __webpack_public_path__ + "static/media/ally_background_m2.b0162fa7.jpg";